// 印花模块
export const QRY_USER_QUAL = '/app/promotion/prom_qry_user_qual.cgi';
export const QRY_QUAL_PRIZE = '/app/promotion/prom_qry_qual_prize.cgi';
export const EXCHANGE_PRIZE = '/app/promotion/prom_exchange_prize.cgi';
export const EXCH_ACT_PRIZE_INFO = '/app/task/exch_act_prize_info.cgi';
export const MULACTION_EXCHANGE_PRIZE = '/app/promotion/prom_mulaction_exchange_prize.cgi';
export const QRY_USER_QUAL_LOG_STAT = '/app/promotion/prom_qry_user_qual_log_stat.cgi';
